export function unreachable(v: never): never {
    throw new Error(`Reached the unreachable with value: ${JSON.stringify(v)}`);
}
